export default "/assets/images/leaf-fluttering-in-wind.9badd55922b7754f.png";